module.exports = __webpack_public_path__ + "img/Cuban Sandwich-Pork.437cda85.jpg";